import styled from 'styled-components';
import IconPointerDown from './IconPointerDown';
var IconPointerUp = /*#__PURE__*/styled(IconPointerDown).withConfig({
  displayName: "IconPointerUp",
  componentId: "c11n-8-107-0__sc-vfw4gs-0"
})(["transform:rotate(180deg);"]);
export default IconPointerUp;